// node_modules
import { FC } from "react";
import { Link } from "react-router-dom";
// Components
import { FindestButton } from "Components";
// Types
import { TUsPatentDTO } from "Types";
// styles
import styles from "./patentDocumentContent.module.scss";
import "styles/documentHighlights.scss";
// Helpers
import { DateHelperSingleton } from "Helpers";
// Custom hooks
import { useTextSelection } from "Hooks";

type TPatentDocumentContentProps = {
    patent: TUsPatentDTO,
    highlightedAbstract?: string,
    highlightedClaims?: string
}

export const PatentDocumentContent: FC<TPatentDocumentContentProps> = ({patent, highlightedAbstract, highlightedClaims}: TPatentDocumentContentProps) => {
    // Let
    const { setSelectedTextOnMouseEvent, selectedText, selectionBoundingClientRect } = useTextSelection();
    
    // Render
    return (
        <>
            <div className={styles.patentDocumentContentFullInfo}>
                <div className={[styles.infoColumn, styles.metadataContainer].join(" ")}>
                    <Link to={{ pathname: patent.url }} target={"_blank"} rel={"noopener noreferrer"} >
                        <FindestButton title="Link to Patent" />
                    </Link>

                    {patent.issueDate ?
                        <div className={styles.metadata}>
                            <h5>Issuing date</h5>
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} className="publishing-date">
                                {DateHelperSingleton.getFormattedDate(new Date(patent.issueDate))}
                            </h6>
                        </div>
                        : <></>
                    }

                    {patent.filingDate ?
                        <div className={styles.metadata}>
                            <h5>Filing date</h5>
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} className="publishing-date">
                                {DateHelperSingleton.getFormattedDate(new Date(patent.filingDate))}
                            </h6>
                        </div>
                        : <></>
                    }

                    {patent.assignees && patent.assignees.trim().length > 0 ?
                        <div className={styles.metadata}>
                            <h5>Assignees</h5>
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} className="author">
                                {patent.assignees}
                            </h6>
                        </div>
                        : <></>
                    }
                    {patent.inventors && patent.inventors.trim().length > 0 ?
                        <div className={styles.metadata}>
                            <h5>Authors</h5>
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} className="author">
                                {patent.inventors}
                            </h6>
                        </div>
                        : <></>
                    }
                </div>
                <div className={styles.infoColumn}>
                    <h5>Abstract</h5>
                    {patent.abstract ?
                        highlightedAbstract ?
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} dangerouslySetInnerHTML={{ __html: highlightedAbstract }}></h6>
                            :
                            <h6 onMouseUp={setSelectedTextOnMouseEvent} style={{ marginBottom: "1rem" }}>{patent.abstract}</h6>
                        : <h6 style={{ marginBottom: "1rem" }}>No Abstract was provided</h6>
                    }

                    {patent.claims ?
                        <>
                            <h5>Claims</h5>
                            {highlightedClaims ?
                                <h6 onMouseUp={setSelectedTextOnMouseEvent} dangerouslySetInnerHTML={{ __html: highlightedClaims }}></h6>
                                :
                                <h6 onMouseUp={setSelectedTextOnMouseEvent}>{patent.claims}</h6>
                            }
                        </>
                        : <></>
                    }
                </div>
            </div>
        </>
    );
};